import React from 'react'

function Header() {
  return (
    <section className="as_header_wrapper">
            <div className="as_info_detail">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <ul>
                                <li>
                                    <a href="javascript:;">
                                        <div className="as_infobox">
                                            <span className="as_infoicon">
                                                <svg xmlns="http://www.w3.org/2000/svg"  preserveAspectRatio="xMidYMid" width="17" height="17" viewBox="0 0 17 17" style={{ marginTop: "5px", display: "block" }} >
                                                    <image href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAMAAAAMs7fIAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAkFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8AAACWvj/iAAAALnRSTlMAs+Z9A8OHq1DyTbvnW1I94To8yZWCSMyETosK4MVR8Y0V3IYNlLpJ0QVasu2nQJZtCAAAAAFiS0dEAIgFHUgAAAAJcEhZcwAALiMAAC4jAXilP3YAAACASURBVBjTXc7ZEoIwDAXQsKiIooiKG3VBwZX7/59HIFPael+SnpkkJSLPD8hOOAIwtmUC/BEkkZGpSGxk1r3niTW16GTpHEtZVo5kLGtHaMO07btc798x7bkegKPIqWBS5+jC5Sp0KzHkLvRQhvT6SkM9XHy+elBv6xefr/9riFp+ORMcFJRCjQAAAABJRU5ErkJggg==" width="17" height="17"/>
                                                  </svg>
                                            </span>
                                        +91 8172888061
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript:;">
                                        <div className="as_infobox">
                                            <span className="as_infoicon">
                                                <svg xmlns="http://www.w3.org/2000/svg"  preserveAspectRatio="xMidYMid" width="18" height="13" viewBox="0 0 18 13">
                                                    <image href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAANCAMAAACTkM4rAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAllBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8AAADAm+O6AAAAMHRSTlMAnPKljr/GhqKttZn1jLe+g/bxiLvDfn07z9cuDFuRD7MXFoq9k66LrKSjlo+U852fXjOJAAAAAWJLR0QAiAUdSAAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAIZJREFUCNdNj0kSgkAQBFMccUNFcFfABRX3+v/rHCB0qENFRx4qsqElrxG1wdBRIz5d1KPvyIChCDRi/CMTQk2JpJhZTeYspAjPnmG957O07VVIK9bShq3+yOwSTEqSxRWyWyl7pYfjSTlxuRXozMU5XBWggpvzKriLh7Mqk/OEl97NHz98AaD8G1UEUcOeAAAAAElFTkSuQmCC" width="18" height="13"/>
                                                  </svg>
                                                  
                                            </span>
                                       info@astrogurujii.com
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-6">
                            <div className="as_right_info">
                                <div className="as_search_wrapper">
                                        <input type="text" name="" className="form-control" id="" placeholder="Search..."/>
                                        <a href="#">
                                            <svg xmlns="http://www.w3.org/2000/svg"  preserveAspectRatio="xMidYMid" width="15" height="15" viewBox="0 0 15 15">
                                                <image href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAMAAAAMCGV4AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAtFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8AAADolZgzAAAAOnRSTlMAXdn8970vurJeTXPTdLwqZWdUIn4O6rmFUtE8ot9q0sLE4wRbI7/OcIMXvnVf+rPVcW18wLBrbmiCc40geAAAAAFiS0dEAIgFHUgAAAAJcEhZcwAALiMAAC4jAXilP3YAAACDSURBVAjXVYvXEoJAEAQHcwIxYFYEA0bMaf7/w7zl4KrYh+nqqVkAsApFlsoVpFdlrd5otmhrddhO6LIj6LKX7vr0VA6G2R84khgbdybiU+OzufjCuL9UEYSZrrhWuTGDbZRgx73gcORJ92fGweVK/8a7LrzHM3pZwJsf5O7LX76w4z/cdAviAFLW+gAAAABJRU5ErkJggg==" width="15" height="15"/>
                                              </svg>
                                              
                                        </a>
                                </div>
                                <div className="as_user">
                                    <a href="https://admin.astrogurujii.com">
                                        <img src="assets/images/profile.jpg" alt=""/>
                                        <span className="as_add_user">+</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-lg-3 col-md-3 col-sm-4 col-xs-6">
                        <div className="as_logo">
                            <a href="/">
                                <img src="assets/images/logo.8119d31cf7380532ba8b.png" alt=""/>
                            </a>
                        </div>
                    </div>
                    <div className="col-lg-9 col-md-9 col-sm-8 col-xs-6">
                        <div className="as_right_info">
                            <div className="as_menu_wrapper">
                                <span className="as_toggle">
                                    <img src="assets/images/svg/menu.svg" alt=""/>
                                </span>
                                <div className="as_menu">
                                    <ul>
                                        <li><a href="/" className="active">Home</a></li>
                                        <li><a href="/about">About us</a></li>
                                        {/* <li><a href="javascript:;">pages</a>
                                            <ul className="as_submenu">
                                                <li><a href="service.html">service</a></li>
                                                <li><a href="service_single.html">service single</a></li>
                                                <li><a href="appointments.html">appointment</a></li>
                                                <li><a href="pricing.html">pricing plans</a></li>
                                                <li><a href="error.html">404</a></li>
                                            </ul>
                                        </li> */}
                                        {/* <li><a href="javascript:;">shop</a>
                                            <ul className="as_submenu">
                                                <li><a href="shop.html">Shop</a></li>
                                                <li><a href="shop_single.html">Shop Single</a></li>
                                            </ul>
                                        </li> */}
                                        {/* <li><a href="javascript:;">blog</a>
                                            <ul className="as_submenu">
                                                <li><a href="blog.html">blog</a></li>
                                                <li><a href="blog_single.html">blog single</a></li>
                                            </ul>
                                        </li> */}
                                        <li><a href="/contact">Contact Us</a></li>
                                    </ul>
                                </div>
                            </div>
                            {/* <a href="javascript:;" className="as_wishlist"><img src="assets/images/svg/wishlist.svg" alt=""/></a> */}
                            {/* <div className="as_cart">
                                <div className="as_cart_wrapper">
                                    <span><img src="assets/images/svg/cart.svg" alt=""/><span className="as_cartnumber">02</span></span>
                                </div>
        
                                <div className="as_cart_box">
                                    <div className="as_cart_list">
                                        <ul>
                                            <li>
                                                <div className="as_cart_img">
                                                    <img src="assets/images/p1.jpg" className="img-responsive"/>
                                                </div>
                                                <div className="as_cart_info">
                                                    <a href="#">Yellow Sapphire</a>
                                                    <p>1 X $20.00</p>
                                                    <a href="javascript:;" className="as_cart_remove"><i className="fa fa-trash"></i></a>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="as_cart_img">
                                                    <img src="assets/images/p2.jpg" className="img-responsive"/>
                                                </div>
                                                <div className="as_cart_info">
                                                    <a href="#">yantra</a>
                                                    <p>1 X $10.00</p>
                                                    <a href="javascript:;" className="as_cart_remove"><i className="fa fa-trash"></i></a>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="as_cart_total">
                                        <p>total<span>$30.00</span></p>
                                    </div>
                                    <div className="as_cart_btn">
                                        <button type="button" className="as_btn">view cart</button>
                                        <button type="button" className="as_btn">checkout</button>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </section> 
  )
}

export default Header